import { getForcedSellerReferralCodeFromPathname } from "@/lib/partners/forced-seller"
import { normalizeSellerReferralCode } from "@/lib/seller-referral/seller-code-cookie"

export type SellerReferralPageCapture = {
  code: string | null
  resetWindow: boolean
}

/**
 * Prioridade na visita: LP com vendedor forçado > `?vendedor=` > cookie/LS existente.
 * A LP da campanha (ex.: Park Club) não deve perder a carteira para um `?vendedor=` de outra origem.
 */
export function resolveSellerReferralCodeForPageCapture(input: {
  pathname: string | null | undefined
  urlCode: string | null | undefined
  localStorageCode: string | null | undefined
  cookieCode: string | null | undefined
}): SellerReferralPageCapture {
  const forced = getForcedSellerReferralCodeFromPathname(input.pathname)
  if (forced) return { code: forced, resetWindow: true }

  const url = normalizeSellerReferralCode(input.urlCode)
  if (url) return { code: url, resetWindow: true }

  const existing =
    normalizeSellerReferralCode(input.localStorageCode) ??
    normalizeSellerReferralCode(input.cookieCode)
  if (existing) return { code: existing, resetWindow: false }

  return { code: null, resetWindow: false }
}
